import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  border-radius: ${(p) => p.theme.spacing(0.75)};
  padding: ${(p) => p.theme.spacing(0.5)};
  border: 1px solid ${(p) => p.theme.palette.grey[200]};
`;
